import { useEffect } from 'react';
import { useAvatarStore } from '../stores/avatarStore';
import { useAuth } from './useAuth';

export const useAvatar = () => {
  const { user } = useAuth();
  const { avatarData, isLoaded, isLoading, error, loadAvatar, updateAvatar, clearAvatar } = useAvatarStore();

  // Auto-load avatar when user changes
  useEffect(() => {
    if (user?.username && !isLoaded && !isLoading) {
      console.log('🔍 useAvatar - Auto-loading avatar for user:', user.username);
      loadAvatar(user.username);
    }
  }, [user?.username, isLoaded, isLoading]);

  return {
    avatarData,
    isLoaded,
    isLoading,
    error,
    handle: avatarData?.handle || user?.username || '',
    loadAvatar,
    updateAvatar,
    clearAvatar,
  };
};
